import * as React from 'react';
import { SVGProps } from 'react';

const IconUploadSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 13v2h14v-2H1zm3.465-5.137 2.541-2.535-.012 6.595h2l.012-6.595 2.53 2.535 1.414-1.414L8.006 1.5 3.051 6.449l1.414 1.414z" />
  </svg>
);
export default IconUploadSizeS;
